import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { CollectionsEffects } from './collections-feature.effects';
import { CollectionsFacades } from './collections-feature.facades';
import { COLLECTIONS_FEATURE_KEY, collectionsReducer } from './collections-feature.reducer';

@NgModule({
    imports: [
        StoreModule.forFeature(COLLECTIONS_FEATURE_KEY, collectionsReducer),
        EffectsModule.forFeature(CollectionsEffects),
    ],
    providers: [...CollectionsFacades],
    declarations: [],
})
export class CollectionsStoreModule {}
